/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */

import axios from 'axios'
import {eventBus} from "./../main"

import { API_URL } from '../.env'

export class Http {
  constructor (status = { auth: true }) {
    this.isAuth = status && status.auth ? status.auth : false
    this.instance = axios.create({
      baseURL: API_URL
    })

    return this.init()
  }

  init () {
    if (this.isAuth) {
      this.instance.interceptors.response.use(response => {
        console.log(response);
        return response;
      }, error => {
        console.log(error);
        if (error == "Error: Request failed with status code 401") {
          console.log('error');
          eventBus.$emit("value", true);
        }
        // return Promise.reject(error)
      })
      this.instance.interceptors.request.use(request => {
        console.log(request);
        const token = `Bearer ${window.localStorage.getItem("token")}`;
        request.headers.Authorization = token;
        return request;
      }, error => {
        return Promise.reject(error)
      })
    }
    return this.instance
  }
}
